import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';


declare function isEASite(): boolean;

@Component({
  selector: 'app-global-header',
  templateUrl: './global-header.component.html',
  styleUrls: ['./global-header.component.scss']
})
export class GlobalHeaderComponent implements OnInit {

  public isCes: boolean = false;
  public isEqh: boolean = false;
  public isEA: boolean = false;

  constructor(private router: Router) { }

  ngOnInit() {
	if(isEASite()){
		this.isEA = true;
	}else if(this.router.url.indexOf('ces') !== -1){
		this.isCes = true;
	}else{
		this.isEqh = true;
	}
  }

}